import TentativeFillActionErrors from '@/constants/booking/TentativeFillActionErrors'
import i18n from '@/plugins/vue-i18n'

const isTentativeFillActionError = (code) => {
  return Object.values(TentativeFillActionErrors).includes(code)
}

const getTentativeFillErrorToast = (code) => {
  const {
    bookingDoesNotExist,
    bookingAlreadyFilled,
    bookingUnauthorised,
    bookingIsNotTentative,
    bookingRejected,
  } = TentativeFillActionErrors

  switch (code) {
    case bookingIsNotTentative:
    case bookingDoesNotExist:
    case bookingAlreadyFilled:
      return i18n.t('error.bookingUnavailable')
    case bookingUnauthorised:
      return i18n.t('error.bookingUnauthorised')
    case bookingRejected:
      return i18n.t('error.bookingRejected')
    default:
      return i18n.t('error.tentativeFillAPIFailure', [
        i18n.t('app.companyName'),
      ])
  }
}

export { isTentativeFillActionError, getTentativeFillErrorToast }
